export enum BydAuthStorageKeysEnum {
  CURRENT_ACCOUNT_KEY = 'currentAccount',
  TOKEN_KEY = 'token',
  AUTHORIZATION_KEY = 'Authorization',
  REDIRECT_TO = 'redirectTo',
}
